import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchSubcategory } from 'store/actions/subcategories/fetchSubcategories';
import utils from 'helpers/utils';

class SubCategoryField extends React.Component {
    componentDidMount() {
        const { data, id, fetchData } = this.props;

        if (!id || !utils.isEmpty(data)) {
            return;
        }

        fetchData();
    }

    render() {
        const { data, id } = this.props;

        if (!id || utils.isEmpty(data)) {
            return null;
        }

        return (
            <div>
                { data.name }
            </div>
        );
    }
}

SubCategoryField.propTypes = {
    data: PropTypes.object,
    fetchData: PropTypes.func.isRequired,
    id: PropTypes.number,
};

const mapStateToProps = (state, props) => {
    const { id } = props;

    return {
        data: state.subcategories.data[id],
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        fetchData: () => {
            const { id, parentId } = props;

            // Fetch the subcategories.
            dispatch(fetchSubcategory({
                id: id,
                parentId: parentId,
            }));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SubCategoryField);



// WEBPACK FOOTER //
// ./src/pages/products/productRelated/SubCategoryField.js